var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.025 4.0993C20.025 3.71874 19.8243 3.3656 19.4899 3.16675C19.1554 2.9679 18.7435 2.94733 18.395 3.11875L14.3042 5.1107L7.98838 3.05704C7.70322 2.96447 7.39694 2.98504 7.12938 3.11532L2.62313 5.30955C2.23939 5.49812 2 5.87868 2 6.29353V18.3618C2 18.7423 2.20067 19.0955 2.53512 19.2943C2.86957 19.4932 3.28146 19.5138 3.62999 19.3423L7.7173 17.3504L13.8183 19.332C13.667 19.1126 13.5191 18.8829 13.3748 18.6498C12.9875 18.0224 12.6038 17.3024 12.3186 16.531L8.75585 15.3756V5.62154L13.2621 7.08551V10.49C14.3535 9.26259 15.9729 8.48776 17.7684 8.48776C18.564 8.48776 19.3244 8.63861 20.0215 8.91632L20.025 4.0993ZM17.7719 10.1334C15.4378 10.1334 13.5473 11.9437 13.5473 14.1756C13.5473 16.5378 15.8039 19.332 17.0185 20.6657C17.4269 21.1114 18.1204 21.1114 18.5288 20.6657C19.7434 19.332 22 16.5378 22 14.1756C22 11.9437 20.1095 10.1334 17.7754 10.1334H17.7719ZM16.3637 14.2476C16.3637 13.4899 16.9938 12.8762 17.7719 12.8762C18.5499 12.8762 19.1801 13.4899 19.1801 14.2476C19.1801 15.0053 18.5499 15.619 17.7719 15.619C16.9938 15.619 16.3637 15.0053 16.3637 14.2476Z",
    fill: "#54FF99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.4ce1017f7f9d3ba041b7224de1d37b66.svg";
export { ForwardRef as ReactComponent };